import React from 'react';
import { createPortal } from 'react-dom';
import styles from './ConsentModal.module.css';

/**
 * Модальное окно согласия перед редиректом на авторизацию Hytale.
 *
 * Рендерится через портал в document.body, чтобы не наследовать
 * stacking-context родительских fixed-элементов (например, <header>).
 *
 * Показывает, какие данные запрашивает приложение и что оно не может делать.
 * Кнопка «Продолжить» запускает OIDC-поток (onContinue),
 * «Отмена» закрывает окно (onCancel).
 */
const ConsentModal = ({ open, onContinue, onCancel }) => {
  if (!open) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.logoRow}>
            <span className={styles.logoMark} aria-hidden="true">IW</span>
            <span className={styles.appName}>InterWorld</span>
          </div>
          <p className={styles.title}>
            запрашивает доступ к вашему аккаунту Hytale
          </p>
        </div>

        <div className={styles.section}>
          <p className={styles.sectionLabel}>Приложение получит доступ к:</p>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <span className={styles.listIcon} aria-hidden="true">✓</span>
              <span>Игровые профили (имя, UUID, скин)</span>
            </li>
          </ul>
        </div>

        <div className={styles.section}>
          <p className={styles.sectionLabel}>Приложение не может:</p>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <span className={styles.listIconNo} aria-hidden="true">✕</span>
              <span>Изменять данные вашего аккаунта</span>
            </li>
            <li className={styles.listItem}>
              <span className={styles.listIconNo} aria-hidden="true">✕</span>
              <span>Совершать покупки от вашего имени (для покупок потребуется отдельное подтверждение)</span>
            </li>
          </ul>
        </div>

        <div className={styles.notice}>
          Вы будете перенаправлены на сайт Hytale. Ваши данные вводятся только на
          официальном сайте Hytale и не передаются серверам InterWorld.
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>
            Отмена
          </button>
          <button type="button" className={styles.continueBtn} onClick={onContinue}>
            Продолжить
          </button>
        </div>

        <p className={styles.terms}>
          Авторизуясь, вы принимаете Условия использования и Политику
          конфиденциальности InterWorld.
        </p>
      </div>
    </div>,
    document.body
  );
};

export default ConsentModal;
